// Combating Graphic
var combatingGraphic = document.querySelector('.combating-graphic');


if (combatingGraphic) {
  var startTrigger = combatingGraphic.querySelector('.combating-graphic__start-trigger');
  
  startTrigger.addEventListener('click', (e)=>{
    combatingGraphic.classList.add('is-active')
  });

  var bubbles = combatingGraphic.querySelectorAll('.combating-graphic__bubble');
  bubbles.forEach((bubble) => {
    bubble.addEventListener('click', (e)=>{
      resetBubbles();
      bubble.classList.add('is-active')
    });
  });

  var close = combatingGraphic.querySelector('.combating-graphic__close');
  close.addEventListener('click', (e)=>{
    combatingGraphic.classList.remove('is-active')
  });
}


function resetBubbles() {
  var bubbles = combatingGraphic.querySelectorAll('.combating-graphic__bubble');
  bubbles.forEach((bubble) => {
    bubble.classList.remove('is-active');
  });

}
